export { NAV } from "../layouts/navigation/merchantCatalog";

export const can = (role, roles) => !roles || roles.includes(role);

export const ROLE_LABEL = {
  super_admin: "Super Admin", admin: "Admin", supervisor: "Supervisor",
  agent: "Agent", auditor: "Auditor", sales_dealer: "Sales Dealer", customer: "Customer",
  sister_company: "Sister Company",
};
